<script setup lang="ts">
defineProps<{ percent?: number; days?: number }>();
</script>

<template>
  <section class="preorder-terms" :aria-label="$t('preorder_label')">
    <div class="preorder-term">
      <Icon name="lucide:coins" size="18" class="preorder-term-icon" aria-hidden="true" />
      <div>
        <p class="preorder-term-title">{{ $t('preorder_advance_terms', { percent }) }}</p>
        <p class="preorder-term-note">{{ $t('preorder_balance_cod_short') }}</p>
      </div>
    </div>
    <div class="preorder-term">
      <Icon name="lucide:truck" size="18" class="preorder-term-icon" aria-hidden="true" />
      <div>
        <p class="preorder-term-title">{{ $t('preorder_dispatch_short', { days }) }}</p>
        <p class="preorder-term-note">{{ $t('preorder_after_advance') }}</p>
      </div>
    </div>
    <p class="preorder-delivery-note">{{ $t('preorder_delivery_short') }}</p>
  </section>
</template>

<style scoped>
.preorder-terms {
  padding: 14px;
  border: 1px solid var(--el-border-color-lighter);
  border-radius: 12px;
  background: var(--el-bg-color);
}

.preorder-term {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.preorder-term + .preorder-term {
  margin-top: 12px;
}

.preorder-term-icon {
  flex-shrink: 0;
  margin-top: 1px;
  color: var(--el-color-primary);
}

.preorder-term-title {
  margin: 0;
  color: var(--el-text-color-primary);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
}

.preorder-term-note,
.preorder-delivery-note {
  margin: 3px 0 0;
  color: var(--el-text-color-regular);
  font-size: 12px;
  line-height: 1.5;
}

.preorder-delivery-note {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid var(--el-border-color-lighter);
}
</style>
